<ng-template #loading>
  <div>Loading...</div>
  <div *ngIf="hasError()" class="error-message">{{ getErrorMessage() }}</div>
</ng-template>
<div *ngIf="isReady else loading">
  <ng-template #mobile>
    <router-outlet></router-outlet>
  </ng-template>
  <app-desktop *ngIf="isDesktop() else mobile"></app-desktop>
</div>
